import { configureStore } from '@reduxjs/toolkit'
import { setupListeners } from '@reduxjs/toolkit/query'
import { baseApi } from './api/baseApi'

// The store holds server state and nothing else, today.
//
// That is not an oversight. Client state for this client is *selection* —
// which placement the author is looking at — and selection lives in the
// URL, because a selection that is not linkable cannot be sent to a
// colleague and cannot survive a reload. So there is no slice here yet.
//
// What must never appear is a **dirty-state slice**. The moment the store
// accumulates edits waiting to be saved, one-intent-per-control has been
// reversed and the client has become a second model of the document —
// which is the thing the write side accepts intents in order to avoid.
// Redux is here for where the visual designer goes, when drag state and
// multi-panel coordination stop being local; it is not here to hold
// documents.
export const store = configureStore({
  reducer: {
    [baseApi.reducerPath]: baseApi.reducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(baseApi.middleware),
})

// Refetch on reconnect. Not on window focus: authoring reads are exact
// (they fold the aggregate) and an editor that re-reads whenever the tab
// regains focus would discard a half-typed field for no new information.
setupListeners(store.dispatch)

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
